<template>
  <component :is="tag">
    <template v-if="claimed.eventName === 'JOB_SHARED' && claimed.job && claimed.job.id">
      <strong>{{ claimed.tokenCost | plural('token', true) }}</strong>
      for sharing <router-link :to="{ name: 'JobShow', params: { jobID: claimed.job.id } }">{{ claimed.job.title || 'a role' }}</router-link>
      <span class="text-muted">- {{ claimed.createdAt | timeAgo }}.</span>
    </template>
    <template v-if="claimed.eventName === 'SHARE_VISITED' && claimed.job && claimed.job.id">
      <strong>{{ claimed.tokenCost | plural('token', true) }}</strong>
      for a visit on your share of <router-link :to="{ name: 'JobShow', params: { jobID: claimed.job.id } }">{{ claimed.job.title || 'a role' }}</router-link>
      <span class="text-muted">- {{ claimed.createdAt | timeAgo }}.</span>
    </template>
    <template v-if="claimed.eventName === 'APPLICATION_CREATED' && claimed.application && claimed.application.id">
      <strong>{{ claimed.tokenCost | plural('token', true) }}</strong>
      for <router-link :to="{ name: 'Referrals' }">a new application</router-link>
      on <router-link :to="{ name: 'JobShow', params: { jobID: claimed.application.job.id } }">{{ claimed.application.job.title || 'a role' }}</router-link>
      <span class="text-muted">- {{ claimed.createdAt | timeAgo }}.</span>
    </template>
    <template v-if="claimed.eventName === 'APPLICATION_CONFIRMED' && claimed.application && claimed.application.id">
      <strong>{{ claimed.tokenCost | plural('token', true) }}</strong>
      for <router-link :to="{ name: 'Referrals' }">a new confirmed application</router-link>
      on <router-link :to="{ name: 'JobShow', params: { jobID: claimed.application.job.id } }">{{ claimed.application.job.title || 'a role' }}</router-link>
      <span class="text-muted">- {{ claimed.createdAt | timeAgo }}.</span>
    </template>
    <template v-if="claimed.eventName === 'APPLICATION_INTERVIEW' && claimed.application && claimed.application.id">
      <strong>{{ claimed.tokenCost | plural('token', true) }}</strong>
      for <router-link :to="{ name: 'Referrals' }">an interview</router-link>
      on <router-link :to="{ name: 'JobShow', params: { jobID: claimed.application.job.id } }">{{ claimed.application.job.title || 'a role' }}</router-link>
      <span class="text-muted">- {{ claimed.createdAt | timeAgo }}.</span>
    </template>
  </component>
</template>

<script>
import distanceInWords from 'date-fns/distance_in_words';

export default {
  props: {
    claimed: {
      type: Object,
      required: true,
    },
    tag: {
      type: [ String, Function ],
      default: 'span',
    },
  },
  filters: {
    timeAgo(createdAt) {
      return distanceInWords(new Date(), createdAt, { addSuffix: true });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rewards/ClaimedDescription.vue